import { create } from "zustand";
import type { UIState } from "@/types/ui";

type UIActions = {
  focusLocation: (locationId: string) => void;
  resetFocus: () => void;
  selectLocation: (locationId: string) => void;
  setActiveStep: (step: number) => void;
};

export const useUIStore = create<UIState & UIActions>((set) => ({
  activeStep: 0,
  focusLocation: (locationId) => set({ focusedLocationId: locationId, isZoomed: true, selectedLocationId: locationId }),
  focusedLocationId: null,
  isZoomed: false,
  resetFocus: () => set({ focusedLocationId: null, isZoomed: false }),
  selectedLocationId: null,
  selectLocation: (locationId) => set({ selectedLocationId: locationId }),
  setActiveStep: (step) => set({ activeStep: step }),
}));
